import r2wc from "@r2wc/react-to-web-component";
import { PaymentErrorContainer } from "../components/PaymentErrorContainer";

const PaymentErrorWebComponent = r2wc(PaymentErrorContainer, {
  props: {
    error: "string",
    apiKey: "string",
    fleetId: "string",
    stripePublishableKey: "string",
    theme: "string",
    onRetry: "function",
    onGoBack: "function",
  },
  events: {
    onRetry: { bubbles: true, composed: true },
    onGoBack: { bubbles: true, composed: true },
  },
});

if (!customElements.get("fm-payment-error")) {
  customElements.define("fm-payment-error", PaymentErrorWebComponent);
}
